import { render, staticRenderFns } from "./HolooStatus.vue?vue&type=template&id=54eaba4a&scoped=true"
import script from "./HolooStatus.vue?vue&type=script&lang=js"
export * from "./HolooStatus.vue?vue&type=script&lang=js"
import style0 from "./HolooStatus.vue?vue&type=style&index=0&id=54eaba4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eaba4a",
  null
  
)

export default component.exports